import { serverTimestamp } from 'firebase/firestore'
import { getAuth } from 'firebase/auth'
import db from '../db/db'

export interface SubmitDisputeInput {
  diveId: string
  reason: string
  details: string
}

export async function submitDispute(
  input: SubmitDisputeInput
): Promise<string> {
  const auth = getAuth()
  const currentUser = auth.currentUser

  if (!currentUser) {
    throw new Error('Please sign in to submit a dispute')
  }

  const result = await db.addItem('disputes', {
    diveId: input.diveId,
    disputerId: currentUser.uid,
    reason: input.reason,
    details: input.details,
    status: 'open',
    createdAt: serverTimestamp(),
    resolvedAt: null,
    resolvedBy: null,
    resolutionNotes: null
  })

  return result.id
}
